import { request } from "./request";

export function getShareDetail(contentId){
    var split = contentId.split('&');
    console.log(split[0])
    return request({
        url:'content/media/details',headers:{'Content-Type':'application/x-www-form-urlencoded','x-api-version':'v1'},params:{contentId:split[0]}}
    )
}

export function getRecommend(contentId){
    var split = contentId.split('&');
    console.log(split[0])
        return request({
        url:'content/recommend',headers:{'Content-Type':'application/x-www-form-urlencoded','x-api-version':'v1'},params:{contentId:split[0]}}
    )
}


// WEBPACK FOOTER //
// ./src/components/network/share.js